import { render, staticRenderFns } from "./ResendSentEmail.vue?vue&type=template&id=d8b856f6&"
import script from "./ResendSentEmail.vue?vue&type=script&lang=js&"
export * from "./ResendSentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b856f6')) {
      api.createRecord('d8b856f6', component.options)
    } else {
      api.reload('d8b856f6', component.options)
    }
    module.hot.accept("./ResendSentEmail.vue?vue&type=template&id=d8b856f6&", function () {
      api.rerender('d8b856f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/ResendSentEmail.vue"
export default component.exports